/**
 * Escolhe entre a forma masculina e a feminina.
 *
 * Em português, grupo misto vai para o masculino — regra da norma culta, e é
 * o que a Junta espera ver.
 */
export function flexionar(c, masculino, feminino) {
    return c.sexo === 'F' ? feminino : masculino;
}
/**
 * Concordância de um conjunto de pessoas. Um só sócio herda o sexo dele;
 * vários sócios vão para o plural, e para o masculino se houver ao menos um
 * homem.
 */
export function concordanciaDe(sexos) {
    const numero = sexos.length > 1 ? 'PLURAL' : 'SINGULAR';
    const sexo = sexos.some((s) => s === 'M') ? 'M' : 'F';
    return { sexo, numero };
}
/** Plural simples do português para as palavras que aparecem em contrato. */
export function pluralizar(palavra) {
    if (/(ão)$/.test(palavra))
        return palavra.replace(/ão$/, 'ões');
    if (/(m)$/.test(palavra))
        return palavra.replace(/m$/, 'ns');
    if (/(r|z|s)$/.test(palavra))
        return `${palavra}es`;
    if (/(al|el|ol|ul)$/.test(palavra))
        return palavra.replace(/l$/, 'is');
    if (/il$/.test(palavra))
        return palavra.replace(/il$/, 'is');
    return `${palavra}s`;
}
export const TERMOS = {
    socio: { ms: 'sócio', fs: 'sócia', mp: 'sócios', fp: 'sócias' },
    socioUnico: {
        ms: 'sócio único',
        fs: 'sócia única',
        mp: 'sócios únicos',
        fp: 'sócias únicas',
    },
    administrador: {
        ms: 'administrador',
        fs: 'administradora',
        mp: 'administradores',
        fp: 'administradoras',
    },
    empresario: {
        ms: 'empresário',
        fs: 'empresária',
        mp: 'empresários',
        fp: 'empresárias',
    },
    brasileiro: {
        ms: 'brasileiro',
        fs: 'brasileira',
        mp: 'brasileiros',
        fp: 'brasileiras',
    },
    inscrito: { ms: 'inscrito', fs: 'inscrita', mp: 'inscritos', fp: 'inscritas' },
    portador: { ms: 'portador', fs: 'portadora', mp: 'portadores', fp: 'portadoras' },
    residente: { ms: 'residente', fs: 'residente', mp: 'residentes', fp: 'residentes' },
    domiciliado: {
        ms: 'domiciliado',
        fs: 'domiciliada',
        mp: 'domiciliados',
        fp: 'domiciliadas',
    },
    nascido: { ms: 'nascido', fs: 'nascida', mp: 'nascidos', fp: 'nascidas' },
    comanditado: {
        ms: 'comanditado',
        fs: 'comanditada',
        mp: 'comanditados',
        fp: 'comanditadas',
    },
    comanditario: {
        ms: 'comanditário',
        fs: 'comanditária',
        mp: 'comanditários',
        fp: 'comanditárias',
    },
    natural: { ms: 'natural', fs: 'natural', mp: 'naturais', fp: 'naturais' },
    impedido: { ms: 'impedido', fs: 'impedida', mp: 'impedidos', fp: 'impedidas' },
    investido: { ms: 'investido', fs: 'investida', mp: 'investidos', fp: 'investidas' },
    declarado: { ms: 'declarado', fs: 'declarada', mp: 'declarados', fp: 'declaradas' },
    // "incapaz" não flexiona em gênero, só em número — e é por isso que a tabela
    // é explícita em vez de derivada por regra.
    incapaz: { ms: 'incapaz', fs: 'incapaz', mp: 'incapazes', fp: 'incapazes' },
    o: { ms: 'o', fs: 'a', mp: 'os', fp: 'as' },
    do: { ms: 'do', fs: 'da', mp: 'dos', fp: 'das' },
    ao: { ms: 'ao', fs: 'à', mp: 'aos', fp: 'às' },
    pelo: { ms: 'pelo', fs: 'pela', mp: 'pelos', fp: 'pelas' },
    unico: { ms: 'único', fs: 'única', mp: 'únicos', fp: 'únicas' },
    mesmo: { ms: 'mesmo', fs: 'mesma', mp: 'mesmos', fp: 'mesmas' },
};
/** Flexiona um termo do vocabulário conforme a concordância do sujeito. */
export function termo(chave, c) {
    const t = TERMOS[chave];
    if (c.numero === 'PLURAL')
        return c.sexo === 'F' ? t.fp : t.mp;
    return c.sexo === 'F' ? t.fs : t.ms;
}
/** Concorda um verbo entre singular e plural. */
export function verbo(c, singular, plural) {
    return c.numero === 'PLURAL' ? plural : singular;
}
/**
 * Primeira letra em maiúscula, resto intacto.
 *
 * Existe porque `termo()` devolve a forma minúscula — que é a certa no meio da
 * frase — e várias cláusulas começam com um artigo flexionado: "O
 * administrador declara" / "A administradora declara". Sem isto, cada cláusula
 * inventa o próprio jeito de capitalizar, e uma delas erra.
 */
export function capitalizar(texto) {
    return texto.charAt(0).toUpperCase() + texto.slice(1);
}
//# sourceMappingURL=genero.js.map